exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".schedule-container[data-v-698e4b1c]{background-color:#f5f5f5;overflow-y:scroll;height:calc(100vh - 194px)}", ""]);

// exports
